import { SxStyle } from '../../../types/style';

const contentContainer: SxStyle = {
    padding: 2,
    minHeight: 'calc(100vh - 55px)'
};

const contentContainerGridItem1Typography: SxStyle = {
    fontWeight: 700
};

const contentContainerGridItem2Box: SxStyle = {
    width: '100%',
    height: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
};

const contentContainerGridItem2BoxButton: SxStyle = {
    marginRight: '8px',
    backgroundColor: 'black',
    ':hover': {
        background: 'black',
    },
};

const contentContainerGridItem3Paper: SxStyle = {
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap',
    listStyle: 'none',
    p: 0.5,
    m: 0,
};

const contentContainerGridItem3PaperListItemChip: SxStyle = {
    marginRight: '5px'
};

// dialog
const dialogDialogTitle: SxStyle = {
    fontWeight: 700
};

const dialogIconButton: SxStyle = {
    position: 'absolute',
    right: 8,
    top: 8,
    color: (theme) => theme.palette.grey[500],
};

// columns datagrid
const dataGridBox: SxStyle = {
    margin: '14px'
}

export const userStyle = {
    contentContainer,
    contentContainerGridItem1Typography,
    contentContainerGridItem2Box,
    contentContainerGridItem2BoxButton,
    contentContainerGridItem3Paper,
    contentContainerGridItem3PaperListItemChip,
    dialogDialogTitle,
    dialogIconButton,
    dataGridBox
};